import myaxios from '@/myaxios.js'
const state = {
    drug_type: [],
    drug_unit: [],
    drug_way: []

}

const mutations = {
    SET_DRUG_TYPE: (state, drugType) => {
        state.drug_type = drugType
    },
    SET_DRUG_UNIT: (state, drugUnit) => {
        state.drug_unit = drugUnit
    },
    SET_DRUG_WAY: (state, drugWay) => {
        state.drug_way = drugWay
    }
}

const actions = {
    ADD_DRUG_TYPE: function({ commit, getters }) {
        myaxios.get(`/api/AcisSystem/DrugType/Get`).then((data) => {
            let drugTypes = _.map(data, drugType => {
                return {
                    label: `${drugType.name}`,
                    value: drugType.id,
                    jianpin: drugType.abbr,
                    disabled: drugType.is_deleted,
                    IsPrescription: drugType.is_prescription,
                    PrescriptionDocKey: drugType.prescription_doc_key,
                    PrescriptionNoGeneratorProc: drugType.prescription_no_generator_proc
                }
            })
            commit(`SET_DRUG_TYPE`, drugTypes)
        }).catch(error => {
            console.log(error)
        })
    },
    ADD_DRUG_UNIT: function({ commit, getters }) {
        myaxios.get(`/api/AcisSystem/DrugUnit/Get`).then((data) => {
            console.log(data)

            let r = _.map(data, d => {
                return {
                    label: `${d.name}`,
                    value: d.id,
                    disabled: d.is_deleted,
                    isspeed: d.is_speed_unit,
                    isconcentration: d.is_concentration_unit
                }
            })
            commit(`SET_DRUG_UNIT`, r)
        }).catch(error => {
            console.log(error)
        })
    },
    ADD_DRUG_WAY: function({ commit, getters }) {
        myaxios.get(`/api/AcisSystem/AddDrugWay/Get`).then((data) => {
            let r = _.map(data, d => {
                return {
                    label: `${d.name}`,
                    value: d.id,
                    jianpin: d.code,
                    disabled: d.is_deleted
                }
            })
            commit(`SET_DRUG_WAY`, r)
        }).catch(error => {
            console.log(error)
        })
    }
}

const getters = {
    drug_type: (state, getters) => {
        return state.drug_type
    },
    drug_unit: (state, getters) => {
        return state.drug_unit
    },
    drug_way: (state, getters) => {
        return state.drug_way
    }
}
export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/drug.js